/** Application copy only. User-authored text is never looked up in this table. */
export const arkmeEnglish: Record<string, string> = Object.fromEntries(`
个人世界|Personal world
说话人排序|Sort speakers
经常出现|Most frequent
最近出现|Most recent
正在补齐说话人列表，排序仍在更新…|Loading the remaining speakers. Order is still updating…
列表尚未完整，当前仅对已加载的说话人排序和搜索。|The list is incomplete. Sorting and search cover loaded speakers only.
显示更多说话人|Show more speakers
语音通话邀请|Voice call invitation
视频通话邀请|Video call invitation
公开快记|Public note
AI 对话|AI conversation
群聊 / 主题邀请|Group / topic invitation
声纹录入邀请|Voiceprint invitation
自动贴图邀请|Auto-sticker invitation
市集扩展|Marketplace extension
点击查看分享内容|Open shared content
分享内容暂不可用|Shared content is unavailable
分享已失效|Share link has expired
分享内容审核中|Shared content is under review
请打开链接确认访问权限|Open the link to check access
预览暂时无法加载，可点击查看|Preview unavailable. Open to view.
正在读取分享预览…|Loading share preview…
另外 {count} 个链接|{count} more links
{count} 条记录|{count} records
今天已识别|Identified today
当天已识别|Identified on this day
今天到期|Due today
当天到期|Due on this day
正在加载当天安排…|Loading arrangements for this day…
当天正在更新…|Updating…
更新失败，已保留当前内容|Update failed. Current content has been kept.
安排加载失败|Unable to load arrangements for this day
暂无安排|No arrangements
到期时间|Due time
添加安排|Add arrangement
输入安排内容|Arrangement content
输入安排内容…|Enter arrangement content…
待创建的安排内容|Draft arrangement content
输入想做的事，完成后先保存，再由AI识别安排。|Describe what you want to do. Finish saves it first, then AI recognizes the arrangements.
移除此条内容|Remove this entry
最多输入10条，每条500字，总计2000字|Up to 10 entries, 500 characters each and 2,000 in total
正在创建…|Creating…
未能确认创建结果，输入已保留；重试不会重复创建。|Could not confirm creation. Your input is retained; retrying will not duplicate it.
AI识别中…|AI recognition in progress…
今天创建|Created today
当天创建|Created on this day
更新识别结果|Update recognition result
安排已保存，未完成AI识别|Saved; AI recognition did not complete
安排已保存，AI识别尚未结束，可稍后更新结果。|Saved. AI recognition is still running; you can update the result later.
安排已保存，暂未获取识别结果，请稍后重试。|Saved. Recognition results are unavailable; try again later.
安排已不可访问，请刷新确认。|Arrangement is unavailable. Refresh to check.
待确认的内容|Content
展开|Expand
创建原文|Original source
创建原文加载失败|Unable to load original source
创建原文暂不可查看|Original source is currently unavailable
暂无创建原文|No original source
内容加载失败|Unable to load content
暂无关联内容|No related content
按空格开始排序，方向键移动，空格放置，Escape 取消。按 Enter 展开原文。|Press Space to pick up, arrow keys to move, Space to drop, or Escape to cancel. Press Enter to expand the source.
已开始拖动安排|Arrangement picked up
已更新安排插入位置|Arrangement insertion position updated
当前位置不可放置|Cannot drop at this position
拖动结束|Drag ended
已取消拖动|Drag cancelled
当前服务暂不支持手动排序|Manual sorting is unavailable for this service
安排|Arrangements to confirm
正在推进的事项|Work in progress
每一步都算数|Every step counts
已识别 · 待确认|Identified · Awaiting confirmation
安排|Arrangements
已识别|Identified
跟进中|Following
已完成|Completed
返回日历|Back to calendar
通知时间|Notification time
未设置通知时间|No notification time set
安排加载失败|Unable to load arrangements
暂无安排，可将其他区块的安排拖到这里|No arrangements. Drag one here from another column.
安排未能完成移动，已重新读取实际状态；请确认后重试。|The move could not be completed. Review the refreshed status and try again.
部分安排暂未同步，请重试加载后再操作。|Some arrangements could not be refreshed. Retry loading before continuing.
录音记录|Recording history
最近录音记录|Recent recordings
各设备同步的录音记录，按开始时间倒序|Synced recordings from your devices, newest start time first
录音设备|Recording device
录音模式|Recording mode
累计时长|Recorded duration
服务端确认停止|Stop confirmed by server
关闭录音记录|Close recording history
当前账号已上传的录音，按开始时间倒序|Uploaded recordings for this account, newest start time first
设备录音|Device recording
文件录音|Audio file
正在加载录音记录…|Loading recordings…
录音记录加载失败|Could not load recordings
暂无录音记录|No recordings yet
用量与额度|Usage & limits
详情 ›|Details ›
月度赠送 Token|Monthly included tokens
已用|Used
/ 剩余|/ Remaining
查看会员 Token 权益 ›|View included tokens ›
月度额度与充值余额分开计量，不合并折算|Monthly tokens and prepaid credit are tracked separately.
AI 充值余额|AI credit balance
充值 ›|Add credit ›
可用|Available
任务预占|Reserved for tasks
，结算后释放未用部分|; unused credit is released after settlement
用于按余额计费的 AI 功能，不代表月度 Token 用尽后自动接续|For credit-billed AI features. Not an automatic fallback when monthly tokens run out.
云端存储|Cloud storage
/ 共|/ Total
查看存储权益 ›|View storage benefits ›
语音转文字|Speech to text
查看语音转文字权益 ›|View speech-to-text benefits ›
语音输入与快记语音的月度权益，不含下方录音文件转写|Monthly allowance for voice input and voice notes; excludes recording-file transcription below.
录音转写|Recording transcription
暂未做限制|No limit currently
用量统计待接入|Usage reporting coming soon
指录音板块的文件转写，不含 AI 总结|Recording-file transcription; excludes AI summaries
登录后查看用量与额度|Sign in to view usage and limits
查看会员权益 ›|View membership benefits ›
思考过程|Reasoning
Agent · 内容由 AI 生成，仅供参考|Agent · AI-generated content; verify important information
模型选择|Models
上一次发送结果尚未确认，请先用原请求标识完成对账。|The previous request is unconfirmed. Check its status before retrying.
重试确认|Check again
正在加载更早内容…|Loading earlier content…
暂无对话记录|No conversations yet
思考内容|Reasoning
选择模型|Choose a model
仅影响之后发起的新任务，进行中的任务会继续使用原模型|Applies to new tasks only. Running tasks keep their current model.
推荐|Recommended
关闭|Close
清除上下文|Clear context
将创建新的 Agent 会话，已有聊天记录不会删除。|Starts a new Agent session. Existing chat history will be kept.
取消|Cancel
确认|Confirm
添加长文|Add an article
＋新建长文|＋ New article
预览|Preview
正在加载…|Loading…
重试|Retry
加载更多|Load more
只添加到输入框，不会立即发送|Adds to your draft without sending
欢迎加入|Welcome
群里有 Arkme 的内测用户、作者（群主）和团队伙伴。|Meet Arkme testers, its creator, and the team in this group.
来唠唠嗑、反馈 Bug、问问题、提建议，都可以～你的想法，或许会成为 Arkme 的下一次改变。|Chat, report bugs, ask questions, or share ideas. Your feedback could shape Arkme's next update.
刚开始用 Arkme？可以先逛逛：|New to Arkme? Start here:
先去试试，用着有疑问或新想法，随时回来聊。|Give it a try, and come back with any questions or ideas.
预占余额|Reserved credit
当前运行的任务预先占用的余额，任务完成后将返还剩余余额。|Credit reserved for running tasks. Unused credit is released when tasks finish.
充值|Add credit
余额充值|Add credit
APP 与 Arkme 3.0 共用积分，充值到账后即可使用|AI points are shared between the app and Arkme 3.0, and available once credited.
当前余额|Current balance
刷新|Refresh
充值套餐|Credit packages
正在加载充值套餐…|Loading credit packages…
暂无可购买套餐|No packages available
支付方式|Payment method
订单号：|Order:
暂时无法查询订单状态|Unable to check order status
下次重试约|Next retry in about
秒后|seconds
支付宝收银台已在浏览器中打开|Alipay checkout opened in your browser
完成支付后返回 Arkme，页面会自动确认结果。|Return to Arkme after paying. Payment will be confirmed automatically.
使用微信扫码支付|Scan with WeChat to pay
支付操作暂不可用|Payment is temporarily unavailable
支付金额|Amount
· 剩余|· Remaining
支付已确认，无需重复支付|Payment confirmed. Do not pay again.
余额到账中，到账后会自动刷新当前余额。|Your credit is being added. The balance will refresh automatically.
已到账|Credit added
已到账，正在刷新当前余额|Credit added. Refreshing balance…
当前余额已刷新：|Balance refreshed:
余额暂未刷新：|Balance not yet refreshed:
支付凭据已过期，请重新生成。|Payment details expired. Generate new ones.
订单已关闭。|Order closed.
订单支付失败。|Payment failed.
重新生成|Generate again
刷新余额|Refresh balance
重新打开支付页面|Reopen checkout
立即重试|Retry now
正在加载 Bot 对话…|Loading Bot conversation…
创建 Bot|Create Bot
接入方式|Connection method
简介（可选）|Description (optional)
消息免打扰|Mute notifications
连接信息|Connection details
安全设置|Security
已加入群聊|Joined groups
删除 Bot|Delete Bot
名称|Name
更换头像|Change avatar
启用关键词校验|Require keyword validation
关键词|Keywords
启用签名 Token 校验|Require signature token validation
启用 IP 白名单|Enable IP allowlist
IP 白名单（每行一个）|IP allowlist (one per line)
Webhook 地址|Webhook URL
凭据预览|Credential preview
显示完整凭据|Show full credentials
群聊中允许 @ 此 Bot|Allow mentioning this Bot in groups
尚未加入群聊|No groups joined
回到今日|Today
重试互动|Retry interactions
暂无聊天记录|No messages yet
更早月份|Earlier months
你|You
正在更新…|Updating…
这一天还没有快记|No notes for this day
加载中…|Loading…
视频记录|Video recording
切换视角|Switch view
示例画面|Demo video
视频记录暂不可用|Video recording unavailable
AI 摘要|AI summary
通话转写|Call transcript
段对话|segments
0 段对话|0 segments
▦ 画面排版|▦ Layout
我|Me
与|with
通话|Calls
选择通话方式|Choose call type
语音通话|Voice call
视频通话|Video call
联系人与通话入口|Contacts & calls
先找到联系人，再发起语音或视频通话；也可以邀请对方主动联系你。|Find a contact to start a voice or video call, or invite someone to call you.
让对方扫描二维码或打开主页链接，在 Arkme 中认识并联系你。|Share your QR code or profile link so others can find you on Arkme.
即我号：|Arkme ID:
复制主页链接|Copy profile link
分享|Share
返回|Back
邀请他人向我发起通话|Invite someone to call me
选择通话类型，生成可分享的邀请链接。|Choose a call type to create a shareable invitation link.
复制链接|Copy link
分享邀请|Share invitation
添加联系人|Add contact
扫一扫二维码添加好友|Scan a QR code to add a contact
已在联系人中 · 点击选择通话方式|Already a contact · Click to choose call type
没有在当前联系人中找到“|No contact found for “
正在读取当前账号资料…|Loading your profile…
暂时无法读取当前账号资料|Unable to load your profile
当前为通话演示版，正式接入账号资料后会打开完整主页。|This is a call demo. Your full profile will be available when account access is connected.
第一版演示|Demo
找联系人，发起语音或视频通话；通话结束后可回放、看摘要和逐句转写。|Start a voice or video call, then review recordings, summaries, and transcripts.
联系人|Contacts
选择联系人即可通话|Choose a contact to call
添加|Add
没有找到相关通话|No matching calls
选择一条通话记录|Select a call
从左侧选择联系人，查看通话详情、回放和转写。|Select a contact on the left to view call details, recordings, and transcripts.
通话详情|Call details
的|'s
这次|This
没有接通|Not connected
接通并完成录制后，可以在这里回放、查看摘要和转写。|Recordings, summaries, and transcripts appear here after a recorded call.
通话录音|Call recording
12 秒交互演示 · 完整通话|12-second demo · Full call
· 正式版播放原录音|· Original recording available in the full version
· 由通话语音自动转写|· Automatically transcribed from the call
已挂断通话|Call ended
生成邀请链接，分享给对方后，对方可向你发起通话。|Create and share an invitation link so someone can call you.
通话类型|Call type
有效期|Validity
失效时间|Expires at
可关闭此弹窗。保持桌面端登录并运行，即可接听对方来电。|You can close this dialog. Keep Arkme running and signed in to receive calls.
预览暂不可用|Preview unavailable
AI 摘要：|AI summary:
摘要生成中…|Generating summary…
摘要生成失败，查看详情|Summary failed. View details.
预览加载失败，查看详情|Preview failed. View details.
示例|Demo
让每一次重要的声音与相见，都能被好好记住。|Remember every meaningful conversation.
发起通话|Start a call
最近联系人|Recent contacts
最近通话|Recent calls
正在读取通话记录...|Loading calls…
加载更多…|Load more…
加载失败，点击重试|Loading failed. Click to retry.
没有更多了|No more results
从一次问候开始|Start with a hello
找一位想联系的人，聊过的声音和画面会留在这里。|Call someone. Your conversations and recordings will appear here.
正在准备通话…|Preparing call…
分享链接，让对方联系我|Share a link to receive a call
没有可呼叫联系人|No contacts available to call
仅使用麦克风|Microphone only
使用摄像头和麦克风|Camera and microphone
还没有找到这个联系人对应的私聊会话，暂时不能从通话页直接呼叫。请先从对话里打开该联系人，或搜索已有私聊联系人。|No direct chat was found for this contact. Open their conversation or search for an existing contact first.
跳过引导|Skip tour
上一步|Previous
视频加载失败，请重试|Video failed to load. Please retry.
禁止再次加入此群|Prevent rejoining this group
开启后，后续邀请、添加或入群审批都会被拒绝，可在群聊设置中解除。|Future invitations and join requests will be blocked. You can lift this restriction in group settings.
主题内昵称：|Name in this topic:
正在加载快记…|Loading notes…
暂无快记|No notes yet
加载快记失败|Failed to load notes
预览中|Previewing
加载更早消息|Load earlier messages
正在加载消息…|Loading messages…
暂无消息|No messages
识别二维码图片添加好友|Add a contact from a QR image
正在处理…|Processing…
这是你自己，不能添加为联系人|You cannot add yourself as a contact
该账号当前无法添加|This account cannot be added right now
二维码加载中…|Loading QR code…
将好友的个人二维码置于框内|Place your contact's QR code in the frame
粘贴或拖入二维码截图|Paste or drop a QR code screenshot
支持 ⌘V / Ctrl+V，也可以直接选择电脑中的图片|Press ⌘V / Ctrl+V, or choose an image from your computer
选择二维码图片|Choose QR code image
条新消息|new messages
暂时无法回到底部，请重试|Unable to jump to the latest message. Please retry.
已移除对话，可在联系人中找回|Conversation removed. Find it again in Contacts.
搜索结果暂不完整，请缩小范围或调整关键词|Results may be incomplete. Narrow your search or change the keywords.
查看媒体消息|View media message
查看文件消息|View file message
暂无搜索结果|No results
加载详情…|Loading details…
该附件已不存在或暂不可访问，请返回结果重新选择|This attachment is unavailable. Go back and choose another result.
返回结果|Back to results
定位到消息|Go to message
DSH 内测|DSH beta
还没加入 DSH 内测群？|Not in the DSH beta group yet?
和内测用户一起聊聊|Chat with fellow beta testers
DSH 内测群|DSH beta group
加入群聊|Join group
登录后查看数据管理|Sign in to manage your data
‹ 数据管理|‹ Data management
管理、迁入和保留属于你的记录。|Manage, import, and preserve your records.
最近删除|Recently deleted
导入数据|Import data
导出数据|Export data
在网页中导入|Import on the web
与 Flutter 桌面端使用同一个导入页面。请在网页中登录同一账号，再选择要导入的文件。|Uses the same import page as the Flutter desktop app. Sign in with the same account and choose your files.
打开导入网页 ↗|Open import page ↗
不会自动上传文件，也不会通过链接传递你的登录凭证。|Files are not uploaded automatically. The link does not contain your credentials.
。浏览不会自动清除数据。|. Browsing does not delete any data.
恢复|Restore
恢复“|Restore “
完整备份|Full backup
条快记 ·|notes ·
个语音 ·|audio clips ·
张图片|images
最近导出：|Last export:
当前插件尚未接入完整文件打包下载。请先在即我手机端或 Flutter 桌面端的「数据管理 → 导出」完成备份。|Full archive download is not yet available here. Use Data management → Export in the mobile or Flutter desktop app.
这里只查询导出条件，不会创建导出任务或消耗导出次数。|This only checks export availability. It does not start an export or use your export allowance.
AI 小结|AI recap
仅基于已加载内容|Based only on loaded content
取消生成|Cancel generation
内容或范围已变化，可手动更新小结。|Content or filters have changed. You can update the recap.
将向账号的云端 AI 发送当前筛选下|The account's cloud AI will receive
段活动预览摘录（最多 24 段 / 6000 字符），可能消耗额度。不额外读取历史，不发送位置字段、原始音视频，不创建 Arko 对话。|activity excerpts (up to 24 / 6,000 characters). This may use your allowance. No extra history, location fields, or original media are sent, and no Arko conversation is created.
查看本次发送的摘录|View excerpts to be sent
确认生成|Generate recap
暂不生成|Not now
正在整理摘录，不会执行其他任务…|Summarizing excerpts. No other tasks will be performed…
来源|Source
基于|Based on
段活动摘录，非完整全天回顾。AI 生成，可能有误，请核对来源。|activity excerpts, not a complete daily review. AI may make mistakes; check the sources.
已有录音回顾|Recording recaps
的录音来源回顾，不代表全天全部活动，也不对应某一小段录音。|recording recap; not a full-day review or a summary of a single clip.
部分录音回顾读取失败，可刷新当天活动重试。|Some recording recaps failed to load. Refresh this day to retry.
此处展示部分回顾，完整内容可在录音板块查看。|Only some recaps are shown. See Recordings for the full content.
我的一天|My day
活动片段|Activity timeline
原始明细|Original records
查看范围|Scope
当前仅显示部分来源。|Only some sources are shown.
概览只统计当前筛选下已加载、可查看的内容，不是全天总量。|This overview counts accessible, loaded content matching your filters, not the full day's totals.
地点|Location
其他群动态|Other group activity
多维活动数据尚未接入，原有日历仍可使用。|Multi-source activity is unavailable. The original calendar remains available.
正在加载当天活动…|Loading this day's activity…
重试加载|Retry loading
仅筛选已确认地点的活动。列表自动补读最多 8 个可见活动的地点，其他活动可展开后手动查看；没有地点标签不代表当时没有位置。|Shows confirmed locations only. Locations load for up to 8 visible activities; expand others to check manually. No label does not mean no location was recorded.
正在加载原始记录…|Loading original records…
重试详情|Retry details
内容已不可访问，请刷新当天活动。|Content is no longer accessible. Refresh this day.
正在读取地点…|Loading location…
重试地点|Retry location
加载更多原始记录|Load more original records
前往原始来源|Open original source
查看活动及其预览不会更改会话已读状态。地点仅来自已加载记录的位置线索，不是全天完整轨迹。|Viewing activities does not mark chats as read. Locations come from loaded records, not a complete daily route.
这条记录没有可确认的设备采集位置，不代表当时没有外出。|No confirmed device location is available for this record. This does not mean you stayed indoors.
采集时间|Captured at
来源设备|Source device
坐标|Coordinates
定位精度|Accuracy
约|About
米|m
这是一次设备定位，不代表连续轨迹、停留时长或整段录音的地点。|A single device location, not a route, visit duration, or location for the entire recording.
录音覆盖范围暂不可用，不代表当天没有录音。|Recording coverage is unavailable. This does not mean there were no recordings.
当天开始|Start of day
当天结束|End of day
已有录音|Recorded
已识别人声|Speech detected
录音覆盖数据不完整，未覆盖区间不能断言为无录音。|Coverage data is incomplete. Uncovered periods may still contain recordings.
已有录音，暂无已识别人声信息；不代表静音。|Audio was recorded, but speech-detection data is unavailable. This does not mean silence.
最近表情保存未确认|Recent emoji save is unconfirmed
重试保存|Retry saving
正在加载最近表情…|Loading recent emoji…
最近表情加载失败|Failed to load recent emoji
最近使用|Recent
默认表情|Default emoji
创作者：牛mo王|Creator: 牛mo王
加载失败|Failed to load
上传中|Uploading
点击重试|Click to retry
处理中|Processing
不可用|Unavailable
暂无收藏表情，点击 + 添加|No saved emoji. Click + to add some.
裁剪扩展头像|Crop extension icon
拖动图片调整位置，使用滑块缩放；最终会生成正方形头像并自动压缩。|Drag to position the image and use the slider to zoom. The square icon will be compressed automatically.
缩放|Zoom
扩展头像|Extension icon
编辑扩展|Edit extension
说明|Description
可见范围|Visibility
请选择可见范围|Choose visibility
仅自己|Only me
公开|Public
该历史可见范围已隐藏，请选择仅自己或公开后保存。|This legacy visibility is no longer supported. Choose Only me or Public before saving.
待上传|Pending upload
扩展预览图|Extension screenshots
发布后可上传预览图|Upload screenshots after publishing
选择图片|Choose images
最多 20 张，第一张作为封面|Up to 20 images. The first is the cover.
封面|Cover
这张预览图暂时无法加载|This preview could not be loaded
版本|Version
更新说明|Release notes
GitHub 仓库（可选）|GitHub repository (optional)
打开扩展管理|Manage extensions
知道了|Got it
评论回复|Replies
原评论|Original comment
全部回复|All replies
还没有回复。|No replies yet.
回复原文 ·|Reply to ·
回复|Reply
用户评价|Reviews
条评论|comments
正在加载评论…|Loading comments…
分享扩展|Share extension
网页链接|Web link
复制|Copy
搜索关联快记中的文件|Search files in related notes
查看来源|View source
文件大小：|File size:
正在加载文件...|Loading file…
打开|Open
另存为|Save as
打开文件夹|Open folder
正在打开…|Opening…
正在保存...|Saving…
重试预览|Retry preview
群成员|Group members
正在读取群成员…|Loading group members…
，点击重试|. Click to retry.
暂无群成员|No group members
已添加|Added
人|people
正在加载群成员|Loading group members
未选择对象|Nothing selected
我的会话|My conversations
正在读取可添加对象…|Loading available contacts…
正在搜索群成员…|Searching group members…
没有找到相关对象|No matches found
暂无陌生人|No other contacts
暂无群聊|No groups
当前没有可添加到本群的 Bot|No Bots available to add to this group
邀请协作者|Invite members
发起人：|Created by:
邀请链接生成失败，请重试|Failed to create invitation. Please retry.
邀请链接已复制|Invitation link copied
扫码加入，或转发邀请链接|Scan to join, or share the invitation link
正在读取 AI 润色设置…|Loading AI polish settings…
不润色|No polishing
新建规则|New rule
服务端未授予当前账号该群的 AI 润色设置权限|You do not have permission to manage this group's AI polish settings
正在整理规则…|Preparing rule…
AI 表达润色|AI writing polish
禁止加入名单|Blocked members
名单中的用户无法通过邀请、添加或入群审批再次加入此群。|Listed users cannot rejoin via invitations or join requests.
正在读取限制名单…|Loading blocked members…
暂无被限制的用户|No blocked members
已禁止再次加入|Rejoining blocked
解除限制|Unblock
重命名|Rename
保存|Save
正在读取昵称…|Loading nickname…
正在加载链接…|Loading links…
加载更多链接|Load more links
字|characters
✎ 编辑|✎ Edit
正在加载长文…|Loading articles…
Markdown 长文暂不可编辑，草稿已保留。|This Markdown article cannot be edited right now. Your draft is saved.
加载更多长文|Load more articles
：不可用]|: unavailable]
稍后|Later
运行能力|Capabilities
进入 TA 的世界|Visit their world
TA 的全部插件|All extensions by this creator
已自动停用|Automatically disabled
更新|Updates
V3 原生|V3 native
详情|Details
市集|Marketplace
正在加载更多…|Loading more…
加载更多失败|Failed to load more
暂无插件|No extensions
该作者暂未发布公开插件|This creator has no public extensions yet
重新加载|Reload
该扩展的制品上传或发布尚未完成，目前没有可安装版本。|This extension has not finished uploading or publishing. No installable version is available.
关于|About
已安装版本|Installed version
市场最新版本|Latest marketplace version
创建时间|Created
卸载只删除当前设备中的扩展制品和 Profile 依赖；如果只是暂时不使用，请关闭上方开关。|Uninstall removes local extension files and profile dependencies. To disable temporarily, use the switch above.
确认卸载|Confirm uninstall
卸载本地扩展|Uninstall local extension
删除会将这个扩展从市集中移除，但不会自动卸载当前设备中的本地副本。|Deletion removes this extension from the marketplace, but does not uninstall the local copy.
确认删除|Confirm deletion
删除市集扩展|Delete marketplace extension
即我会员|Arkme membership
让记录、整理与协作更从容|More room to capture, organize, and collaborate
核心权益|Key benefits
查看完整权益对比 ↗|Compare all benefits ↗
与手机端共用权益说明|Benefits shared with the mobile app
无需重复开通，当前会员权益可在同一账号下使用。|Your membership works across devices on the same account. No second subscription needed.
套餐暂时无法读取。|Plans are temporarily unavailable.
正在读取在售套餐…|Loading available plans…
暂无在售|Not available
套餐|plan
开通|Subscribe
价格来自当前在售套餐。|Prices reflect currently available plans.
桌面端支付开发中，敬请期待。本次不会创建订单或扣款。|Desktop payments are coming soon. No order will be created and you will not be charged.
AI智能体|AI agent
转发给|Forward to
复制文本|Copy text
退出多选|Exit selection
加载中...|Loading…
暂无更多人员信息|No more people
举报和反馈|Report & feedback
你的反馈可以帮助我们持续优化，Arkme 会及时处理。|Your feedback helps us improve. The Arkme team will review it.
举报补充说明|Additional details
快记详情未加载成功：|Failed to load note details:
字数|Characters
记录时长|Duration
查阅/回顾|Views / reviews
次|times
正在补全记忆快照…|Loading memory snapshot…
去开启›|Enable ›
‹ 返回模型列表|‹ Back to models
思考强度|Reasoning effort
正在加载模型…|Loading models…
去充值|Add credit
暂无可用模型|No models available
暂无可 @ 的对象|No one available to mention
共|Total
条延展|extensions
已编辑|Edited
内容较多，当前展示部分转发记录|Only some forwarded records are shown
部分媒体暂时无法加载，请刷新对话后重试|Some media could not be loaded. Refresh the conversation and retry.
内容较多，当前展示部分转发内容|Only some forwarded content is shown
原快记暂不可查看|Original note unavailable
使用反馈与建议|Feedback & suggestions
如有使用问题、功能疑问或改进建议，请在下方留言。反馈异常时，可附上操作步骤及截图。|Leave questions or suggestions below. For issues, include the steps and screenshots if possible.
返回联系人目录|Back to contacts
数字为个人记录数，圆点为录音索引。录音归属与覆盖范围以当天结果为准。|Numbers count personal records; dots indicate recordings. See each day for ownership and coverage.
录音月历暂不可用，仍可点选日期查看。|Recording calendar unavailable. You can still select a date.
刷新月历|Refresh calendar
原版日历|Original calendar
查看完整快记|View full note
发现插件新版本|Extension update available
当前 v|Current v
→ 最新 v|→ Latest v
查看完整更新说明|View full release notes
我的世界|My world
数据管理|Data management
设置|Settings
创建群聊|Create group
群聊名称|Group name
最新|Latest
部分历史附件暂不可用|Some earlier attachments are unavailable
附件暂不可用|Attachment unavailable
正在加载编辑记录…|Loading edit history…
暂无编辑记录|No edit history
重新加载历史附件|Reload earlier attachments
刷新并重新选择|Refresh and select again
音频文字正在导入&转写中|Importing and transcribing audio
音频文字正在导入&转写中|Importing and transcribing audio
正在读取…|Loading…
暂无数据|No data
历史版本：|Version history:
模型：|Model:
待办：|To-do:
场景 ·|Scene ·
心情 ·|Mood ·
示例体验 · 我的一天|Demo · My day
全天候录音|All-day recording
声纹管理|Voiceprints
正在读取录音…|Loading recordings…
录音加载中…|Loading recording…
已选择|Selected
相关快记加载失败|Failed to load related notes
相关快记|Related notes
条|items
正在加载相关快记…|Loading related notes…
暂无相关快记|No related notes
正在加载快记详情…|Loading note details…
图片预览失败|Image preview failed
截图|Screenshot
屏幕共享已停止。拖动框选需要的区域，或使用整张图片。|Screen sharing has stopped. Drag to select an area, or use the full image.
使用整张|Use full image
上传|Upload
查看链接消息|View link message
暂无相关内容|No matching content
快记暂不可用：|Notes unavailable:
内容查找暂不可用：|Content search unavailable:
重试内容查找|Retry content search
会话名称查找未完成：|Conversation name search incomplete:
重试名称查找|Retry name search
正在查找会话名称…|Searching conversation names…
昵称：|Nickname:
DSH 任务暂不可用：|DSH tasks unavailable:
记录详情|Record details
打开会话|Open conversation
当前仅显示本页匹配记录。|Only matching records on this page are shown.
选择一个主题查看关联快记|Select a topic to view related notes
该会话查询失败：|Conversation search failed:
已匹配会话名称，没有匹配的消息内容。可打开会话继续查看。|Conversation name matched, but no messages matched. Open the conversation to explore.
录音·转写暂不可用：|Recordings and transcripts unavailable:
搜索中…|Searching…
一句话，找到所有内容|Find anything with a few words
搜索历史|Search history
快速查找|Quick find
按内容类型浏览|Browse by content type
搜索快记|Search notes
文字背景音|Text background audio
扫码查看我的主页|Scan to view my profile
即我号|Arkme ID
需字母开头 · 最少|Start with a letter · At least
位 · 暂仅可设置一次|characters · Can only be set once
确认创建|Confirm creation
当前绑定的手机号码为|Current phone number:
手机号|Phone number
验证码|Verification code
‹ 返回列表|‹ Back to list
通过分享链接查看 · 只读|Shared link · Read only
个评分|ratings
扩展说明|Extension description
查看 GitHub 仓库|View GitHub repository
分享链接仅用于查看，不授予安装、评论、执行或管理权限。|This link grants viewing access only, not installation, commenting, execution, or management permissions.
退出了群聊|left the group
正在加载链接内容...|Loading link content…
此链接生成时间：|Link created:
正在给|Messaging
发消息|now
AI润色已开启|AI polish enabled
正在加载发给自己的内容…|Loading saved notes…
恢复编辑|Resume editing
核对结果|Check result
核对发送结果|Check send result
清除|Clear
去看看|View
重新编辑:|Editing:
· 点击发送重试|· Click Send to retry
部分附件不可用，请移除后重新添加|Some attachments are unavailable. Remove and add them again.
使用|Use
标签加载失败，|Failed to load tags.
Enter发送|Enter to send
/ Shift+Enter换行|/ Shift+Enter for a new line
Enter发送 / Shift+Enter换行|Enter to send / Shift+Enter for a new line
指定主题|Choose topic
删除|Delete
发给自己|Saved notes
默认分类|Default category
发送给：|Send to:
指定主题 · 已选|Topic · Selected
当前：|Current:
全部|All
移入|Move into
当前主题|Current topic
加载子主题|Load subtopics
拖到这里，变为一级主题|Drop here to make a top-level topic
移出主题|Move out of topic
新主题|New topic
有最新内容的主题靠前|Topics with recent activity first
最多|Most
最多内容的主题靠前|Topics with the most content first
自定义|Custom
可按住主题拖动排序|Drag topics to reorder
将在「|Create under “
」下创建|”
主题名称|Topic name
主题|Topics
正在加载主题…|Loading topics…
”中的|” in
将|Move
系统主题 ·|System topic ·
转写、日总结与时间轴|Transcripts, daily summaries, and timeline
通话记录、录音与 AI 摘要|Call history, recordings, and AI summaries
日历|Calendar
按日期查看快记|Browse notes by date
搜索|Search
快记、主题、录音与 AI 视频|Notes, topics, recordings, and AI videos
通过手机号或即我号搜索|Search by phone number or Arkme ID
新建主题|New topic
搜索对话或消息|Search chats or messages
登录解锁更多功能|Sign in for more features
会话加载失败，请重试|Failed to load conversation. Please retry.
加载或播放失败，请点击播放重试。|Could not load or play audio. Click Play to retry.
下载|Download
我的声音|My voice
管理声纹录入、识别与播放能力|Manage voice enrollment, recognition, and playback
刷新状态|Refresh status
正在加载我的声音…|Loading my voice…
我识别到的人|Recognized people
已识别的声音及我获得的播放权限|Recognized voices and playback permissions granted to me
刷新识别|Refresh recognition
复制邀请链接|Copy invitation link
邀请由对方明确授权，不会自动改变任何人的权限。|The other person must explicitly authorize access. Invitations do not change permissions automatically.
正在加载我识别到的人…|Loading recognized people…
还没有识别到其他人|No other people recognized yet
查看识别详情|View recognition details
加载更多识别人|Load more recognized people
谁能播放我的声音|Who can play my voice
我主动授予的播放权限|Playback permissions I have granted
刷新授权|Refresh permissions
正在加载谁能播放我的声音…|Loading voice permissions…
还没有人可以播放你的声音|No one has permission to play your voice
加载更多授权|Load more permissions
识别详情|Recognition details
正在加载识别详情…|Loading recognition details…
正在加载声纹记录…|Loading voiceprint records…
暂无声纹记录|No voiceprint records
声纹记录|Voiceprint records
· 命中|· Matches
邀请对方授权|Request permission
查找用户|Find a user
正在查找邀请对象…|Finding people to invite…
复制专属邀请|Copy personal invitation
‹ 返回录音|‹ Back to recordings
账户与声音|Account & voice
管理你的声纹、对外授权和录音中已识别的人。授权变更均需由你明确操作。|Manage your voiceprint, permissions, and people recognized in recordings. Permission changes always require your explicit action.
录入我的声纹|Enroll my voice
请在安静环境中，用自然语速连续说话 3 至 60 秒。|Speak naturally for 3 to 60 seconds in a quiet place.
Arkme 是你的 AI 个人全息记忆中枢，可以记录生活灵感、日程安排和重要瞬间。它会帮你整理日常想法、回顾关键记忆，并在需要时陪你重新看见自己的生活脉络。|Arkme is your personal AI memory hub. Capture ideas, plans, and important moments. Organize your thoughts, revisit meaningful memories, and rediscover the story of your life.
停止录音|Stop recording
正在加载公开插件…|Loading public extensions…
当前公开插件|Public extensions
个|items
查看全部|View all
提醒|Reminder
录入声纹后就能听见这条文字|Enroll your voice to hear this text
再想想|Not now
世界|World
看看大家此刻正在记录什么|See what others are sharing
的世界|'s world
TA 公开分享的内容|Publicly shared content
发布|Publish
待预览|Preview pending
发世界|Post to World
记录此刻，也分享给世界。发布失败时会显示原因，草稿不会被清空，可以继续编辑后重试。|Capture and share a moment. If publishing fails, your draft is kept so you can edit and retry.
发布后会作为公开动态展示|Your post will be public
图片|Images
张，单张不超过 20MB|images, up to 20 MB each
添加图片|Add images
可一次选择多张图片|Select multiple images at once
继续添加|Add more
收起|Collapse
取消回复|Cancel reply
评论加载中…|Loading comments…
还没有评论|No comments yet
多选暂不可用|Multiple selection unavailable
已选|Selected
请扩大窗口以勾选消息|Widen the window to select messages
退出|Exit
展开另外|Show another
条更早互动|earlier interactions
这条快记正文暂时不可用，请稍后重试。|This note's content is unavailable. Please try later.
查看录音|View recording
结束并保存|Stop & save
本次最长|Maximum duration:
分钟 · 请勿关闭页面或让电脑休眠|minutes · Keep this page open and your computer awake
待提交录音（仅当前浏览器保存）|Pending recordings (saved in this browser only)
重试上传|Retry upload
下载备份|Download backup
查看处理进度|View progress
我的|Mine
他人|Others
上传文件|Upload files
已完成|Completed
点击、拖拽上传音频文件（支持多选）|Click or drop audio files here (multiple files supported)
支持 WAV、MP3、M4A 格式|WAV, MP3, and M4A supported
松开上传至 Arkme|Drop to upload to Arkme
文件名称|File name
录音时长|Duration
文件大小|File size
数据归属|Data ownership
上传状态|Upload status
处理耗时|Processing time
个文件|files
导入|Import
暂时无法加载已完成任务|Unable to load completed tasks
请检查网络后重新加载|Check your connection and reload
暂无已完成任务|No completed tasks
导入完成的音频会显示在这里|Imported audio will appear here
当前显示上次结果，云端同步失败|Showing previous results. Cloud sync failed.
正在加载更多...|Loading more…
发现|Found
个重复文件|duplicate files
将跳过这些文件，并继续导入其余音频|These files will be skipped. Other audio will be imported.
跳过并继续|Skip & continue
是否删除|Delete
删除后无法恢复|This cannot be undone
确定修改音频文件的数据归属吗？|Change this audio file's data ownership?
我的数据写入时间轴，他人仅保存|My data appears on the timeline; others' data is only saved
阶段 / 模型|Stage / model
状态|Status
开始时间|Started
结束时间|Ended
用户耗时|User time
模型耗时|Model time
关系 / 说明|Relation / notes
暂无耗时信息|No timing data
已录 00:00:|Recorded 00:00:
即我|Arkme
今天|Today
安排|Plans
录音|Recordings
单击文字，长按语音|Click for text, hold for voice
快记|Notes
探索|Explore
时间轴|Timeline
总结|Summary
转写|Transcript
文件|Files
暂无时间轴|No timeline yet
可根据当天转写生成时间轴|Generate a timeline from this day's transcript
在手机上开启全天候录音|Start all-day recording on your phone
打开手机即我，登录同一账号|Open Arkme on your phone and sign in with the same account
操作演示，请在手机上开启|Demo only. Start recording on your phone.
重新播放|Replay
我知道了|Got it
本机正在录音|Recording on this device
点击查看录音 · 本机保存中|View recording · Saving locally
正在读取候选…|Loading candidates…
添加“|Add “
”为说话人|” as a speaker
批量修改|Update all
处“|instances of “
仅修改当前片段|Update this segment only
跟随播放|Follow playback
滚轮缩放|Scroll to zoom
录音处理中，人声结果待更新|Processing recording. Speech results pending.
无录音|No recording
导入音频|Import audio
占比|Share
个片段|segments
总时长:|Total duration:
转写对比|Compare transcripts
豆包转写中…|Transcribing with Doubao…
背景音|Background audio
秒|s
个片段转写失败|segments failed to transcribe
个片段未识别到人声|segments had no detected speech
正在读取发给自己入口…|Loading Saved notes…
正在检查自己和主题转发能力…|Checking forwarding availability…
服务端暂不支持向自己或主题转发录音|Forwarding recordings to yourself or topics is not supported by the server yet
已转发|Forwarded
正在读取目标…|Loading destinations…
加载更多目标|Load more destinations
录音片段（|Recording segment (
上一个|Previous
下一个|Next
与 Arkme 沟通任务|Work with Arkme
+ 开始第一个任务|+ Start your first task
想先从什么开始？|What would you like to start with?
我的内容|My content
任务工作区|Task workspace
选择 Agent 要处理的目录|Choose a directory for the Agent
正在读取目录…|Loading directories…
当前目录没有子目录|No subdirectories
上一级|Parent directory
正在加载联系人资料…|Loading contact details…
昵称|Nickname
联系人资料|Contact details
备注|Note
编辑|Edit
语音聊天|Voice call
视频聊天|Video call
修改备注|Edit contact name
备注名|Contact name
图片加载失败|Image failed to load
正在加载 TA 的世界…|Loading their world…
暂无公开快记|No public notes
群内昵称|Group nickname
简介|Description
此 Bot 暂不支持私聊|This Bot does not support direct messages
返回候选摘要|Back to candidate summary
标记为说话人|Identify speaker
选择已有说话人，或创建一个新身份|Choose an existing speaker or create a new identity
出现|Appeared on
天 · 相关片段|days · Related segments
正在加载说话人选项…|Loading speakers…
选择说话人|Choose speaker
新建说话人|New speaker
重新加载选项|Reload options
正在加载团队成员…|Loading team members…
团|Team
位成员|members
团队成员|Team members
声音片段|Voice clips
试听相关片段，确认这是谁的声音|Listen to clips to identify this voice
正在加载声音片段…|Loading voice clips…
暂无可听声音片段|No playable voice clips
标记成功|Speaker identified
说话人已标记，联系人目录正在刷新。|Speaker identified. Refreshing contacts…
最近：|Latest:
天|days
有效声音|Valid audio
相关片段|Related segments
推测说话人|Suggested speaker
正在加载候选详情…|Loading candidate details…
去听声音|Listen to voice
重试候选详情|Retry candidate details
你与|You and
的线下交流记录|'s in-person conversations
正在读取相关录音…|Loading related recordings…
暂无相关录音|No related recordings
没有更多内容了|No more content
时段总结|Period summary
正在加载原文…|Loading original text…
重新加载原文|Reload original text
对话|Chats
我的账户|My account
华为 ID|Huawei ID
已绑定|Connected
未绑定|Not connected
邮箱|Email
微信号|WeChat
绑定|Connect
换绑|Change
解/换绑|Disconnect / change
解绑手机号|Disconnect phone number
返回更换手机号|Back to changing phone number
确认解绑|Confirm disconnect
当前仅绑定了手机号，请先绑定其他登录方式|Link another sign-in method before unlinking your phone number.
账号状态未确认，请重新打开账号设置|Account status could not be confirmed. Reopen account settings.
绑定中…|Connecting…
通用|General
隐私与权限|Privacy & permissions
用户协议|Terms of service
隐私条款|Privacy policy
个人资料|Profile
个人菜单|Profile menu
免费版|Free
读取中|Loading
读取中…|Loading…
待确认|Unconfirmed
正在读取会员状态|Loading membership
会员状态暂时无法确认，点击重试|Membership unavailable. Click to retry.
查看更多存储、转写与协作权益|Explore storage, transcription, and collaboration benefits
永久会员|Lifetime membership
有效期以手机端为准|Check the mobile app for expiry
{date} 到期|Expires {date}
赠送会员 · {date}|Gifted membership · {date}
查看用量与额度详情|View usage and limits
月度 Token|Monthly tokens
录音文件转写暂未做限制；用量统计待接入，灰轨不代表已用为零|Recording transcription is not limited yet. Usage reporting is pending; the gray track does not mean zero usage.
刷新用量与额度|Refresh usage and limits
Token 额度已用比例|Token usage percentage
云端存储已用比例|Storage usage percentage
语音转文字已用比例|Speech-to-text usage percentage
用量与额度详情|Usage and limits details
Arko 操作|Arko actions
消息详情|Message details
调整消息详情宽度|Resize message details
作者头像|Author avatar
当前模型|Current model
发送|Send
停止当前任务|Stop task
停止当前 Arko 任务|Stop Arko task
搜索自己的长文|Search your articles
正在准备附件|Preparing attachments
待发送附件|Pending attachments
入群欢迎|Group welcome
预占余额说明|About reserved credit
微信支付二维码|WeChat Pay QR code
AI 余额充值流程|Add AI credit
Bot 设置|Bot settings
选择 Bot 头像文件|Choose Bot avatar
上传 Bot 头像|Upload Bot avatar
上传头像|Upload avatar
给 Bot 起个名字|Name your Bot
Bot 接入方式|Bot connection method
更换 Bot 头像|Change Bot avatar
编辑 Bot 资料|Edit Bot profile
上个月|Previous month
下个月|Next month
跳转月份|Go to month
跳转年月|Go to month and year
调整日历高度|Resize calendar
拖动调整高度，方向键也可调整|Drag or use arrow keys to resize
打开快记详情|Open note details
当前用户头像|Your avatar
客户端日历|Calendar
当天内容|This day's content
刷新当天快记|Refresh daily notes
当天快记列表|Daily notes
播放视频记录|Play video recording
视频播放控制|Video controls
视频通话回放|Video call playback
视频回放画面排版|Video layout
我的 Arkme 主页二维码|My Arkme profile QR code
添加联系人页面|Add contact page
搜索联系人|Search contacts
联系人搜索结果|Contact search results
我的 Arkme 二维码|My Arkme QR code
通话记录列表|Call history
联系人快捷入口|Quick contacts
通话类型筛选|Filter call type
通话概览|Call overview
通话录音播放器|Call audio player
通话结束后自动整理|Generated after the call
点击气泡，播放并定位到这一段|Click a bubble to play this segment
聊天式通话转写|Call transcript as chat
通话参与人|Call participants
联系人选择|Contact selection
通话邀请|Call invitation
邀请通话类型|Invitation call type
通话邀请链接|Call invitation link
通话视频预览|Call video preview
搜索通话记录|Search call history
正在准备通话|Preparing call
选择通话联系人|Choose a contact to call
搜索私聊联系人|Search direct contacts
推荐联系人|Suggested contacts
通话体验引导|Call tour
通话引导|Call tour
通话录像播放|Call video playback
通话录像|Call video
录像|Video recording
播放录像|Play video
播放|Play
下载录像|Download video
播放进度|Playback progress
正在加载日历|Loading calendar
移出群聊？|Remove from group?
确认移除|Confirm removal
移除中…|Removing…
调整成员快记侧栏宽度|Resize member notes panel
成员快记|Member notes
聊天预览|Chat preview
预览消息列表|Message previews
截屏|Screenshot
手机号或即我号|Phone number or Arkme ID
备注（可选）|Contact name (optional)
复制即我号|Copy Arkme ID
我的好友二维码|My contact QR code
好友二维码加载中|Loading contact QR code
识别联系人二维码|Read contact QR code
二维码识别|QR code scanner
回到底部|Jump to latest
搜索聊天记录|Search messages
聊天记录搜索|Message search
聊天搜索|Chat search
搜索聊天关键词|Search messages
清空搜索|Clear search
聊天记录分类|Message categories
聊天搜索结果|Chat search results
Arkme 客户端|Arkme app
取消加入群聊|Cancel joining group
确认恢复记录|Confirm restoration
显示方式|Display mode
刷新当天活动|Refresh daily activity
活动类型|Activity type
活动详情|Activity details
记录地点|Recorded location
全天录音覆盖|Daily recording coverage
主题操作|Topic actions
视图选项|View options
选择表情|Choose emoji
表情选择器|Emoji picker
重试保存最近表情|Retry saving recent emoji
重试加载最近表情|Retry loading recent emoji
添加收藏表情|Add saved emoji
收藏表情操作|Saved emoji actions
待裁剪扩展头像|Extension icon to crop
头像缩放|Avatar zoom
更换扩展头像|Change extension icon
切换扩展预览图|Switch extension screenshot
回复列表|Replies
回复原文|Reply to original
选择评分|Choose rating
我的头像|My avatar
扩展评论|Extension reviews
分享弹窗|Share dialog
分享网页链接|Share web link
文件快速查找|Find files
复制图片|Copy image
文件预览|File preview
文件操作|File actions
打开文件|Open file
另存为文件|Save file as
上一个文件|Previous file
下一个文件|Next file
搜索转发对象|Search forwarding destinations
添加成员|Add members
搜索成员候选人|Search people to add
清除搜索|Clear search
群聊邀请二维码|Group invitation QR code
规则列表|Rules
AI 润色设置|AI polish settings
润色规则描述|Polish rule description
例如：语气更轻松，保留原意，不要使用网络热梗|For example: use a relaxed tone, preserve meaning, and avoid internet slang
发送规则描述|Submit rule description
群聊设置|Group settings
解除加入限制？|Allow rejoining?
解除中…|Unblocking…
修改我在本群聊的昵称|Change my group nickname
仅在当前群聊中使用，最多10个字。|Used in this group only, up to 10 characters.
保存中…|Saving…
我在本群聊的昵称|My group nickname
功能引导|Feature tour
外部链接快速查找|Find external links
转发长文详情|Forwarded article details
长文|Articles
请输入标题|Enter a title
长文标题|Article title
请输入正文内容|Enter content
长文正文|Article content
长文快速查找|Find articles
复制扩展链接|Copy extension link
扩展详情|Extension details
扩展统计|Extension statistics
GitHub 来源|GitHub source
在 GitHub 查看作者|View creator on GitHub
正在加载扩展|Loading extension
市集页面导航|Marketplace navigation
Arkme 市集|Arkme marketplace
搜索扩展、功能或作者|Search extensions, features, or creators
搜索扩展、功能或作者…|Search extensions, features, or creators…
清除作者筛选|Clear creator filter
扩展分类|Extension categories
搜索扩展分类|Search extension categories
未找到相关分类|No matching categories
扩展排序|Extension sorting
排序接口暂未同步，当前保持最新创建。|Sorting is unavailable. Showing newest first.
正在加载扩展详情|Loading extension details
扩展详细信息|Extension information
扩展危险操作|Destructive extension actions
会员窗口|Membership dialog
会员等级|Membership tier
会员套餐|Membership plans
消息操作|Message actions
选择转发对象|Choose forwarding destination
转发对象选择|Forwarding destinations
附言（可选）|Message (optional)
转发|Forward
正在输入|Typing
正在输入的成员|Members typing
群消息已读详情|Group read receipts
未读|Unread
举报|Report
举报类型|Report category
请描述具体问题|Describe the issue
提交举报|Submit report
快记统计|Note statistics
记忆快照|Memory snapshot
撤回这条消息？|Recall this message?
撤回后，所有群成员都无法再查看这条消息。此操作不会移除或限制发送者。|After recall, no group member can view this message. The sender will not be removed or restricted.
确认撤回|Confirm recall
撤回中…|Recalling…
消息免打扰已开启|Notifications muted
选择要 @ 的对象|Choose someone to mention
添加延展附件|Add reply attachment
延展此快记|Expand this note
延展此快记...|Expand this note…
发送延展|Send reply
延展作者头像|Reply author avatar
快记延展列表|Note replies
查看原始快记|View original note
查看延展源：{v0}|View reply source: {v0}
返回延展快记|Back to reply
原延展暂时不可用|The previous reply is temporarily unavailable
所在主题|Topic
未指定主题|No topic
延展回复|Replies
暂无延展回复|No replies yet
正在加载延展…|Loading replies…
相关快记列表|Related notes list
相关快记详情|Related note details
录音片段详情|Recording segment details
转发快记详情|Forwarded note details
调整对话列表宽度|Resize conversation list
Arkme 受限工作区导航|Arkme restricted workspace navigation
Arkme 功能导航栏|Arkme navigation
Arkme 主界面|Arkme workspace
个人活动日历|Personal activity calendar
选择活动日期|Choose activity date
完整快记详情|Full note details
插件更新|Extension updates
Arkme 功能导航|Arkme navigation
查看会员权益|View membership benefits
删除中…|Deleting…
暂无转写内容|No transcript yet
转写加载中|Loading transcript
选择生成模型|Choose generation model
示例录音内容|Demo recording
录音日历|Recording calendar
选择录音日期|Choose recording date
月份|Month
月|Month
年份|Year
新录音|New recording
录音详情|Recording details
录音内容|Recording content
对比|Compare
录音多选操作|Recording selection actions
录音体验引导|Recording tour
录音体验|Recording tour
相关快记作者头像|Related note author avatar
实况照片|Live Photo
上一个媒体|Previous media
下一个媒体|Next media
已读|Read
待裁剪的截图|Screenshot to crop
加载链接信息|Load link details
定位链接消息|Go to link message
全局搜索结果类型|Search result types
快记搜索结果|Note search results
主题搜索结果|Topic search results
正在查找会话名称|Searching conversation names
单击查看关联快记，双击打开会话|Click for related notes; double-click to open chat
单击查看匹配摘要，双击打开 DSH 对话|Click for matches; double-click to open DSH conversation
录音转写搜索结果|Transcript search results
搜索对话、快记或消息|Search chats, notes, or messages
全局搜索|Search everywhere
快速查找内容|Quick-find content
发给自己引导|Saved notes tour
我的二维码|My QR code
我的即我二维码|My Arkme QR code
请输入手机号|Enter phone number
Arkme 设置|Arkme settings
查看我的二维码|View my QR code
账号信息|Account information
ArkME 客户端|Arkme app
打开 APP 更新|Open app update
ArkME 插件|Arkme extension
消息头像|Message avatar
原消息附件|Original attachments
分享快记头像|Shared note avatar
快记分享链接|Shared note link
快记分享链接详情|Shared note link details
分享快记链接|Share note link
记录此刻想法|Capture a thought
Arkme 对话目录|Arkme conversations
官方|Official
按日期查看发给自己|Browse saved notes by date
更多发给自己操作|More saved-note actions
正在加载会话内容|Loading conversation
重新编辑保存状态|Edit save status
附件发送状态|Attachment send status
清除发送记录|Clear send records
正在重新载入…|Reloading…
添加内容|Add content
移除待发送长文|Remove pending article
选择标签|Choose tags
转发对象列表|Forwarding destinations
发给自己暂不可用|Saved notes unavailable
说点什么...|Say something…
转发附言|Forwarding message
正在加载数量|Loading count
发给自己主题|Saved-note topics
选择主题|Choose topic
查看解散进度|View dissolution progress
当前主题路径|Current topic path
搜索主题名…|Search topic names…
打开主题|Open topic
搜索主题|Search topics
主题列表|Topic list
重命名主题|Rename topic
解散主题|Dissolve topic
系统主题说明|About system topics
联系作者|Contact creator
创建子主题|Create subtopic
排序方式|Sort by
Arkme 会话列表|Arkme conversations
添加联系人、群聊或 Bot|Add contact, group, or Bot
新任务|New task
Arkme 会话|Arkme conversation
试听本次声纹录音|Preview voice enrollment recording
邀请识别人授权|Request voice permission
邀请对象手机号或 Arkme ID|Phone number or Arkme ID to invite
手机号或 Arkme ID|Phone number or Arkme ID
Arkme 登录|Arkme sign-in
登录|Sign in
世界图片预览|World image preview
图片预览|Image preview
上一张图片|Previous image
下一张图片|Next image
打开全部评论|View all comments
邀请开启声纹|Invite voice enrollment
正在加载更多世界动态|Loading more posts
世界范围|World scope
发布窗口|Post dialog
世界内容|World content
分享此刻的想法…|Share a thought…
选择世界图片|Choose post images
继续添加图片|Add more images
收起评论|Collapse comments
Ctrl / ⌘ + Enter 发送|Ctrl / ⌘ + Enter to send
正在处理|Processing
重试开放平台 MCP 连接|Retry Open Platform MCP connection
多选操作|Selection actions
暂未接入|Not available yet
直接录音状态|Direct recording status
麦克风音量|Microphone level
选择录音文件|Choose recording files
待导入录音|Recordings to import
录音文件列表|Recording files
已完成录音导入|Completed imports
已完成任务内容|Completed task content
正在读取已完成任务|Loading completed tasks
已完成任务加载失败|Failed to load completed tasks
已完成任务表格|Completed tasks table
已完成任务列表|Completed tasks list
重复录音文件|Duplicate recordings
确认删除录音|Confirm recording deletion
取消删除|Cancel deletion
确认修改数据归属|Confirm ownership change
录音引导|Recording guide
说话人编辑|Speaker editor
编辑说话人|Edit speaker
说话人名称|Speaker name
Arkme 用户|Arkme user
添加新说话人|Add speaker
重试读取说话人候选|Retry speaker candidates
真实录音时间轴|Recording timeline
24 小时概览|24-hour overview
24 小时缩略导航|24-hour navigation
详细时间轴，可拖拽平移，滚轮缩放|Detailed timeline. Drag to pan and scroll to zoom.
录音覆盖图例|Recording coverage legend
正在读取录音|Loading recordings
当前窗口说话人统计|Speaker statistics for this range
当前窗口说话人图例|Speakers in this range
全天说话人统计|All-day speaker statistics
全天说话人图例|All-day speakers
关闭全天说话人统计|Close all-day speaker statistics
时间轴记录|Timeline entry
时间未标注|Time unavailable
场景类型|Scene
场景说明|Scene note
环境说明|Environment note
评价|Assessment
评价分数|Assessment score
事件标签|Event tags
时段总结|Period summary
参与者|Participants
说话人备注|Speaker note
待办|To-do
代表性原话|Representative quotes
对话摘要|Dialogue summaries
其他信息|Other information
暂停播放|Pause
转发录音片段|Forward recording segment
转发对象|Forwarding destination
录音转发|Forward recording
重新检查转发能力|Recheck forwarding availability
选择自己和主题|Choose yourself or a topic
已选转发目标|Selected destination
录音转发预览|Recording forward preview
查找转写|Find in transcript
搜索当天转写|Search this day's transcript
搜索命中数|Search matches
清除转写搜索|Clear transcript search
上一个匹配|Previous match
下一个匹配|Next match
开始 Arkme 任务|Start Arkme task
贴一段文字、拖入文件，或直接描述目标…|Paste text, drop a file, or describe your goal…
告诉 Arkme 你的目标|Tell Arkme your goal
添加附件|Add attachment
语音输入|Voice input
开始任务|Start task
可以试试|Try this
工作区选择|Workspace picker
目录路径|Directory path
联系人目录|Contact directory
搜索联系人目录|Search contact directory
编辑备注|Edit contact name
联系操作|Contact actions
输入备注名|Enter contact name
联系人世界|Contact's world
查看个人世界|View personal world
新说话人名称|New speaker name
请输入说话人名称|Enter speaker name
未标记说话人候选|Unidentified speaker candidates
未标记说话人候选摘要|Unidentified speaker summary
说话人统计|Speaker statistics
相关录音|Related recordings
按月份筛选|Filter by month
按时间筛选相关录音|Filter related recordings by time
相关录音详情|Related recording details
调整通话记录宽度|Resize call history
左右拖动调整通话记录宽度，双击恢复默认宽度|Drag to resize call history; double-click to reset
调整输入框高度|Resize composer
上下拖动调整输入框高度，双击恢复自动高度|Drag to resize the composer; double-click for automatic height
左右拖动调整详情宽度，双击恢复默认宽度|Drag to resize details; double-click to reset
头像|Avatar
修改昵称|Edit nickname
裁剪头像|Crop avatar
昵称需为 1–64 个字符|Nickname must be 1–64 characters
请选择不超过 10MB 的 PNG、JPG 或 WebP 图片|Choose a PNG, JPG, or WebP image up to 10 MB
头像上传失败|Avatar upload failed
保存失败，请重试|Save failed. Please retry.
邀请得会员|Invite & earn membership
社交平台|Social accounts
公众号|WeChat Official Account
公众号二维码|Official Account QR code
小红书|Xiaohongshu
抖音|Douyin
即刻|Jike
微博|Weibo
ICP备案号|ICP registration
增值电信业务经营许可证|Value-added telecom license
软著|Software copyright
登录后查看邀请奖励|Sign in to view invitation rewards
我的邀请码|My invitation code
已邀请 {count} 位好友|{count} friends invited
好友可在手机端的“邀请得会员”中填写邀请码，奖励以当前活动规则为准。|Friends can enter this code in Invite & earn membership on mobile. Rewards follow the current promotion rules.
复制邀请码|Copy invitation code
已复制|Copied
复制失败，请手动复制|Could not copy. Please copy manually.
邀请信息暂时无法读取|Invitation details unavailable
正在退出…|Signing out…
暂不可用|Unavailable
暂时无法读取，请刷新重试|Unable to load. Refresh to retry.
未开启|Off
已开启|On
系统通知未开启，点击前往设置|System notifications are off. Open settings.
尚未授权，点击开启|Not authorized. Click to enable.
由系统管理|Managed by the system
正在确认当前 Arkme Host 是否支持文字背景音…|Checking background audio support…
当前 Arkme Host 不支持文字背景音，请升级后重试|This Arkme Host does not support background audio. Update and retry.
正在确认当前账号的背景音会员权益…|Checking background audio benefits…
免费版暂不支持背景音|Background audio is not included in the free plan
暂时无法确认会员权益|Membership benefits unavailable
已开启，输入时自动记录环境背景音并随本条快记保存|Enabled. Ambient audio is captured while typing and saved with this note.
已开启；输入时检测到麦克风权限已拒绝，请在浏览器站点设置中允许|Enabled, but microphone permission was denied. Allow it in your browser's site settings.
账号开关已开启，但当前浏览器不支持麦克风录音|Enabled for your account, but this browser cannot record microphone audio
已开启，首次输入时会请求麦克风权限|Enabled. Microphone permission will be requested when you start typing.
未开启，麦克风权限已拒绝|Off. Microphone permission was denied.
当前浏览器不支持麦克风录音|This browser does not support microphone recording
未开启；开启后会在首次输入时请求麦克风权限|Off. When enabled, microphone permission is requested when you start typing.
即我号不能以数字或符号开头|Arkme ID must start with a letter
即我号仅支持字母、数字、下划线或减号|Use letters, numbers, underscores, or hyphens only
即我号需要5-20个字符|Arkme ID must be 5–20 characters
即我号需要6-20个字符|Arkme ID must be 6–20 characters
✅ 当前即我号可设置|✅ This Arkme ID is available
❌ 即我号仅可设置一次|❌ Arkme ID can only be set once
❌ 即我号格式不正确|❌ Invalid Arkme ID format
❌ 该即我号已被占用|❌ This Arkme ID is taken
服务器繁忙，请稍后重试|Server busy. Please try later.
当前版本读取中…|Loading current version…
等待检查更新|Waiting to check for updates
正在读取更新状态…|Loading update status…
正在安装更新…|Installing update…
更新已下载，前往 APP 更新继续|Update downloaded. Open app updates to continue.
已是最新版本|Up to date
当前未登录|Not signed in
正在读取登录状态…|Checking sign-in status…
待完成登录|Finish signing in
完成手机号绑定后即可登录|Link a phone number to finish signing in
登录 Arkme 后可管理账户|Sign in to manage your account
暂未获取到即我号|Arkme ID unavailable
不可修改|Cannot be changed
修改|Edit
录音中|Recording
设备录音状态|Device recording status
正在同步设备录音状态…|Syncing device recording status…
设备录音状态暂未启用|Device recording status is not enabled yet
同步暂时失败，正在重试|Sync failed temporarily. Retrying
暂无设备上报录音状态|No devices are reporting recording status
已暂停|Paused
已中断|Interrupted
录音异常|Recording error
状态待确认|Status unconfirmed
最后确认|Last confirmed
手动录音|Manual recording
长录音|Long recording
录音，本机正在录音，点击查看|Recordings. This device is recording. Click to view.
确认裁剪|Confirm crop
处理中…|Processing…
外部链接|External links
语音|Audio
当前没有匹配结果|No matching results
图片库|Images
请升级 Arkme 客户端|Please update the Arkme app
编辑资料|Edit profile
正在加载 Bot 设置…|Loading Bot settings…
连接信息|Connection information
安全设置|Security settings
已加入群聊|Joined groups
当前范围|Current scope
全局|All conversations
Arkme 账号|Arkme account
升级会员|Upgrade membership
查看权益|View benefits
显示输入时长|Show typing duration
隐藏输入时长|Hide typing duration
思考中…|Thinking…
调整消息详情宽度|Resize message details
关闭支付弹窗|Close payment dialog
返回 Bot 设置|Back to Bot settings
关闭通话详情|Close call details
通话结束后自动整理|Organized automatically after the call
点击气泡，播放并定位到这一段|Click a bubble to play and locate this segment
关闭通话方式选择|Close call type selection
关闭成员快记|Close member notes
关闭聊天搜索|Close chat search
加入 DSH 内测群|Join the DSH beta group
关闭群成员|Close group members
关闭 AI 润色设置|Close AI polish settings
关闭禁止加入名单|Close restricted members
扩展分类|Extension category
搜索扩展分类|Search categories
未找到相关分类|No matching categories
扩展排序|Sort extensions
排序接口暂未同步，当前保持最新创建。|Sorting is not available yet. Showing newest first.
返回快记详情|Back to note details
返回相关快记列表|Back to related notes
选择生成模型|Choose generation model
查看 Arkme 用户协议|View Arkme terms of service
查看 Arkme 隐私条款|View Arkme privacy policy
返回 Arkme 会话列表|Back to Arkme conversations
关闭 Arkme|Close Arkme
关闭快记详情|Close note details
关闭相关录音|Close related recordings
退出登录|Sign out
记录状态已变化或无法确认可恢复，请刷新最近删除列表。|The record changed or its recovery status could not be verified. Refresh Recently deleted.
部分记录状态无法确认，已隐藏，请刷新或在手机端查看。|Some records could not be verified and have been hidden. Refresh or check on mobile.
本次读取范围内暂无可恢复记录，更多记录请在手机端查看。|No recoverable records in this batch. Check on mobile for more records.
暂无最近删除的记录。|No recently deleted records.
浏览不会自动清除数据。|Browsing does not delete any data.
查看 Token 明细|View Token details
收起 Token 明细|Hide Token details
空间构成|Storage breakdown
收起空间构成|Hide storage breakdown
存储分类明细暂不可用，汇总用量仍有效，请稍后刷新。|The storage breakdown is unavailable. Total usage is still valid; please refresh later.
当前未使用云存储空间|No cloud storage used.
占比按已用空间计算。文字、快记短语音和缩略图不计入存储空间。|Percentages are of used space. Text, short note audio and thumbnails do not count toward storage.
背景音|Background audio
通话录音|Call recordings
其他|Other
月份|Month
选择用量月份|Choose usage month
该月已记录|Recorded this month
模型实际调用用量，不等同于月度额度扣减或充值消费。|Actual model-call usage, not monthly allowance deductions or prepaid spending.
明细可查询起点：{time}|Details available from: {time}
暂时无法读取用量明细。|Usage details could not be loaded.
明细加载失败，已有结果保留。|Could not load more details. Existing results are retained.
用量明细暂时无法确认，请重试|Usage details could not be verified. Please retry.
输入 {input} · 输出 {output}|Input {input} · Output {output}
部分用量字段不可用|Some usage fields are unavailable.
逐次调用明细|Individual model calls
暂无逐次调用记录|No individual calls recorded.
未知模型|Unknown model
缓存：{status} · 命中 {hit} · 未命中 {miss}|Cache: {status} · Hit {hit} · Miss {miss}
 · 缓存创建 {value}| · Cache creation {value}
加载更多调用|Load more calls
该月份暂无 Token 用量记录|No Token usage recorded for this month.
查看 {name} 的调用明细|View calls for {name}
{count} 次模型调用|{count} model calls
缓存：{status}|Cache: {status}
混合命中|Mixed
已命中|Hit
未命中|Miss
未知|Unknown
空间已用满|Storage full
空间不足 10%|Less than 10% space left
暂无可用额度|No allowance remaining
余量较少|Running low
已识别说话人|Recognized speakers
查看录音中已标记和未标记的说话人|See labeled and unlabeled speakers from your recordings
搜索说话人|Search speakers
搜索已加载的说话人|Search loaded speakers
已标记|Labeled
未标记|Unlabeled
录音中标记的人|Labeled in recordings
出现 {v0} 天 · 最近 {v1}|Present on {v0} days · Last {v1}
近 7 天出现 {v0} 天 · 最近 {v1}|Seen on {v0} of the last 7 days · Last {v1}
近 7 天出现 {v0} 天|Seen on {v0} of the last 7 days
已标记说话人详情|Labeled speaker details
查看已确认归属的原始识别身份|View verified recognized voice identities
对应的识别说话人|Recognized voices linked to this person
仅展示近 7 天已转写片段中可核实的关联；完整历史待接口。|Only verified links in transcribed segments from the last 7 days are shown. Full history is pending.
正在查找关联说话人…|Finding linked recognized voices…
近 7 天有发声，但未找到稳定的原始识别身份。|Speech was found in the last 7 days, but no stable source voice identity was available.
近 7 天未找到关联，不代表完整历史中没有。|No link was found in the last 7 days; this does not mean none exists in full history.
近 7 天未见已转写发声 · 全历史待接口|No transcribed speech in the last 7 days · Full history pending
已标记项仅统计近 7 天已转写发声；全历史统计待接口。|Labeled speakers currently show transcribed speech from the last 7 days only. Full-history stats are pending.
出现统计整理中|Preparing presence stats
出现统计更新中|Updating presence stats
出现统计暂不可用|Presence stats unavailable
暂无可统计的录音片段|No countable recording segments
已标记说话人读取失败：|Could not load labeled speakers:
未标记说话人读取失败：|Could not load unlabeled speakers:
说话人列表暂时无法加载|Speaker list could not be loaded
正在加载说话人…|Loading speakers…
正在更新说话人…|Updating speakers…
暂无已识别说话人|No recognized speakers yet
没有匹配的说话人|No matching speakers
加载更多未标记说话人|Load more unlabeled speakers
搜索仅覆盖已加载的说话人，可继续加载更多。|Search covers loaded speakers only. Load more to continue searching.
未标记说话人正在整理，结果可能不完整。|Unlabeled speakers are being prepared. Results may be incomplete.
未标记说话人正在更新，结果可能不完整。|Unlabeled speakers are updating. Results may be incomplete.
未标记说话人整理失败，请稍后刷新。|Could not prepare unlabeled speakers. Refresh later.
暂无可显示的说话人|No speakers can be shown yet
‹ 返回列表|‹ Back to list
说话人已标记，列表正在刷新。|Speaker labeled. Refreshing the list…
{v0} 的 Bot 操作|Bot actions for {v0}
打开 {v0} 的 Bot 操作|Open Bot actions for {v0}
正在加载 Bot 操作…|Loading Bot actions…
查看 Bot 资料|View Bot profile
与 Bot 对话|Chat with Bot
该 Bot 暂不可用|This Bot is currently unavailable
@TA 的消息|Messages mentioning this Bot
TA 的消息|Messages from this Bot
@{v0}的消息|Messages mentioning {v0}
{v0}的消息|Messages from {v0}
仅当前已加载消息|Currently loaded messages only
调整 Bot 消息侧栏宽度|Resize Bot messages panel
关闭 Bot 消息|Close Bot messages
当前已加载消息中暂无匹配内容|No matching messages in the currently loaded range
Bot 已移出群聊|Bot removed from the group
{v0} 将从当前群聊移除，历史消息保留。|{v0} will be removed from this group. Message history will remain.
暂无简介|No description yet
{v0} 的 Bot 资料|Bot profile for {v0}
查看 {v0} 的 Bot 资料|View Bot profile for {v0}
通知型 Bot 暂不支持 @ 对话|Notification Bots do not support @ conversations yet
{v0}人 · {v1} Bot|{v0} people · {v1} Bots
{v0}人|{v0} people
正在读取群 Bot…|Loading group Bots…
Bot 列表加载失败，点击重试|Could not load Bots. Click to retry
新识别 {v0} 个|{v0} newly identified
识别我的声音|Identify my voice
你的声纹正在处理中|Your voiceprint is being processed
已录入声纹，暂未在录音中匹配到你|Voiceprint enrolled. No match found in your recordings yet.
还没有标记你的声音|Your voice has not been labeled yet
打开你的录音，点击说话人名称并选择自己；请先试听确认。|Open your recording, listen to confirm, then click the speaker name and select yourself.
从录音中标记我|Label myself in a recording
管理声纹|Manage voiceprint
`.trim().split('\n').map(line => { const index = line.indexOf('|'); return [line.slice(0, index), line.slice(index + 1)] }))
